import { N40, N600 } from '@atlaskit/theme/colors';
import { SanitizedFormattedHtmlMessage } from '@atlassiansox/bxpkit-core';
import { MobileTrigger } from '@atlassiansox/bxpkit-user-profile-dropdown';
import styled from '@emotion/styled';
import React from 'react';
import { LayoutDevopsType } from '../../../../../model/side-information-component';
import { messages } from '../messages';

export function LayoutDevops({
  logo,
  hideLogoContent,
  logoColor,
  showListContent,
  productListMsg,
  isSideInfoHeader,
  sideInfoHeaderMsg,
  analyticsTrack,
  userInfo,
  switchUserInfo,
  showMultiProduct
}: LayoutDevopsType) {
  let picture;
  let email;
  let devOpsUserDisplay;
  const trackDevOpsChangeAccount = () => {
    if (switchUserInfo !== undefined) {
      analyticsTrack.segment(
        'wac-signup-existing-user-switch',
        switchUserInfo.switchUserOrigin
      );
    }
  };
  const showDevOpsAccountInfo =
    userInfo !== undefined && userInfo.email !== null;
  if (userInfo !== undefined && userInfo.email !== null) {
    picture = `${userInfo.picture}`;
    email = `${userInfo.email}`;
    devOpsUserDisplay = (
      <LoggedInView>
        <MobileTrigger
          userName={email}
          logOutUrl={switchUserInfo?.switchAccountUrl}
          logOutMessage={messages.devopsSwitchAccounts}
          avatarSrc={picture}
          onClick={trackDevOpsChangeAccount}
        />
      </LoggedInView>
    );
  }

  return (
    <DevopsLayout logoColor={logoColor}>
      {isSideInfoHeader && (
        <ProductHeading className="product-heading">
          <SanitizedFormattedHtmlMessage {...sideInfoHeaderMsg} />
        </ProductHeading>
      )}

      {!hideLogoContent && (
        <LogoContainer showListContent={showListContent}>
          <LogosList logoColor={logoColor} showMultiProduct={showMultiProduct}>
            {logo}
          </LogosList>
          {showDevOpsAccountInfo && devOpsUserDisplay}
        </LogoContainer>
      )}

      {showListContent && (
        <FeaturesDiv>
          <SanitizedFormattedHtmlMessage {...productListMsg} />
        </FeaturesDiv>
      )}
    </DevopsLayout>
  );
}
const LoggedInView = styled.div`
  position: relative;
  top: 50px;

  @media only screen and (max-width: 800px) {
    top: 32px;
  }
`;

const DevopsLayout = styled.div<{ readonly logoColor?: string }>`
  font-family: Charlie Display, -apple-system, BlinkMacSystemFont, Segoe UI,
    Roboto, Noto Sans, Ubuntu, Droid Sans, Helvetica Neue, sans-serif;
  -webkit-font-smoothing: antialiased;
  color: ${(props) => (props.logoColor ? props.logoColor : N600)};
`;

const ProductHeading = styled.div`
  font-size: 40px;
  font-weight: 500;
  max-width: 360px;
  line-height: 42px;

  @media only screen and (max-width: 800px) {
    display: none;
  }
`;

const LogoContainer = styled.div<{ readonly showListContent?: boolean }>`
  position: relative;
  margin-bottom: 24px;
  padding-bottom: 4px;
  border-bottom: ${(props) =>
    props.showListContent ? `1px solid ${N40}` : 'none'};
  display: flex;
  justify-content: space-between;
`;

const LogosList = styled.div<{
  readonly logoColor?: string;
  readonly showMultiProduct?: boolean;
}>`
  position: relative;
  display: block;
  width: auto;
  max-width: 500px;
  margin: ${(props) => (props.showMultiProduct ? '40px' : '32px')} 0 40px
    ${(props) => (props.showMultiProduct ? '34px' : '0')};
  padding-left: ${(props) => (props.showMultiProduct ? '15px' : '0')};
  ${(props) =>
    props.showMultiProduct
      ? `border-left: 1px solid ${props.logoColor ? props.logoColor : N40}`
      : null};

  @media only screen and (max-width: 800px) {
    margin: 25px 0px 25px ${(props) => (props.showMultiProduct ? '30px' : '0')};
  }
  ${(props) =>
    props.showMultiProduct
      ? `&:before {
    position: absolute;
    content: '+';
    font-size: 40px;
    left: -35px;
    top: 50%;
    transform: translateY(-50%);
    margin-top: -3px;
    }`
      : null}

  span {
    display: block;
    clear: both;
    max-height: 36px;
    margin: 9px 0;

    svg {
      width: auto;
    }
  }

  canvas,
  svg {
    max-width: 100%;
  }
`;

const FeaturesDiv = styled.div`
  ul {
    list-style-type: none;
    padding: 6px 0 10px 20px;
    margin-top: -30px;

    li {
      position: relative;
      font-size: 22px;
      font-weight: 500;
      margin-bottom: 18px;

      &::before {
        background-image: url("data:image/svg+xml,%3Csvg width='13px' height='13px' viewBox='0 0 13 13' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cg stroke='none' stroke-width='1' fill='none' fill-rule='evenodd' stroke-linecap='round'%3E%3Cg transform='translate(0.000000, -51.000000)' stroke='%2336B37E' stroke-width='1.6'%3E%3Cg transform='translate(1.000000, 45.000000)'%3E%3Cg transform='translate(0.000000, 0.416810)'%3E%3Cpolyline points='1.52655666e-16 11.9766645 3.98219585 17 11 7'%3E%3C/polyline%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
        content: '';
        display: inline-block;
        position: absolute;
        left: -20px;
        top: 11px;
        height: 13px;
        width: 13px;
      }
    }
  }
`;
